import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t, jsxs as e } from "react/jsx-runtime";
import { Line as o } from "@vds-core/lines";
import { Component as n, cloneElement as r, Children as p, Fragment as a } from "react";
import { Sticky as s, StickyContainer as i } from "react-sticky";
import c from "styled-components";
var d = c.div.withConfig({
    displayName: "ComponentWrapper",
    componentId: "VDS__sc-1s14440-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n"]))),
  l = c.div.withConfig({
    displayName: "StyledAccordionItem",
    componentId: "VDS__sc-1s14440-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-bottom: 1px;\n"])));
var u = /*#__PURE__*/function (_n) {
  _inherits(u, _n);
  function u(n) {
    var _this;
    _classCallCheck(this, u);
    var i;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, n)), i = _assertThisInitialized(_assertThisInitialized(_this)), _this.deactivateGroup = function () {
      i.setState(function () {
        return {
          openedState: !1
        };
      });
    }, _this.toggleGroup = function () {
      i.setState(function (_ref) {
        var t = _ref.openedState;
        return {
          openedState: !!i.props.alwaysOpen || !t
        };
      });
    }, _this._onClick = function (t, e) {
      e && e(t, !i.state.openedState), i.toggleGroup(), i.props.onClick && i.props.groupId && i.props.onClick(i.props.groupId);
    }, _this.renderDetail = function (t, e) {
      var _i$props = i.props,
        o = _i$props.groupId,
        n = _i$props.surface,
        p = _i$props.viewport;
      return r(t, {
        key: e + 1,
        alwaysOpen: i.props.alwaysOpen,
        opened: i.props.alwaysOpen || i.state.openedState,
        groupId: o,
        viewport: p,
        surface: n
      });
    }, _this.renderSummary = function (e, o) {
      var _i$props2 = i.props,
        n = _i$props2.groupIndex,
        p = _i$props2.groupId,
        a = _i$props2.surface,
        c = _i$props2.sticky,
        d = _i$props2.testMode,
        l = _i$props2.viewport,
        u = _i$props2["data-analyticstrack"],
        y = _i$props2["data-track"],
        m = _i$props2["data-track-ignore"],
        f = _i$props2["data-clickstream"],
        k = _i$props2["data-sitecat-cta"],
        h = _i$props2["data-sitecat-datatrack"],
        g = _i$props2["data-sitecat-position"],
        I = _i$props2["data-sitecat-level"],
        _ref2 = e && e.props,
        v = _ref2.onClick;
      return c ? t(s, {
        topOffset: 0,
        children: function children(_ref3) {
          var t = _ref3.style;
          return r(e, {
            key: o + 1,
            alwaysOpen: i.props.alwaysOpen,
            opened: i.state.openedState,
            onClick: function onClick(t, e) {
              i._onClick(t, e);
            },
            groupIndex: n,
            groupId: p,
            surface: a,
            style: t,
            sticky: c,
            testMode: d,
            clickStream: f,
            analyticsTrack: u,
            trackIgnore: m,
            track: y,
            dataTrack: h,
            cta: k,
            position: g,
            level: I,
            viewport: l
          });
        }
      }) : r(e, {
        key: o + 1,
        alwaysOpen: i.props.alwaysOpen,
        opened: i.state.openedState,
        clickStream: f,
        analyticsTrack: u,
        track: y,
        dataTrack: h,
        trackIgnore: m,
        cta: k,
        position: g,
        level: I,
        onClick: function onClick(t) {
          i._onClick(t, v);
        },
        groupIndex: n,
        groupId: p,
        surface: a,
        viewport: l
      });
    }, _this.renderGroup = function () {
      var _i$props3 = i.props,
        n = _i$props3.children,
        r = _i$props3.surface,
        s = _i$props3.topLine,
        c = _i$props3.bottomLine;
      return e(d, {
        children: [s && t(o, {
          type: "secondary",
          surface: r
        }), t(l, {
          children: p.map(n, function (t, e) {
            var o = t.type === a ? t.props.children : t;
            o = o instanceof Array ? o[0] : o;
            var n = o.type.componentType ? o.type.componentType : "";
            return "AccordionHeader" === n ? i.renderSummary(o, e) : "AccordionDetail" === n ? i.renderDetail(o, e) : o;
          })
        }), c && t(o, {
          type: "secondary",
          surface: r
        })]
      });
    }, _this.state = {
      openedState: !!_this.props.alwaysOpen || _this.props.opened
    };
    return _this;
  }
  _createClass(u, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(t, e) {
      var o = t.activeID,
        n = t.type,
        r = !!this.props.alwaysOpen || this.props.opened;
      "single" === n && this.props.activeID !== o && e.openedState && !this.props.alwaysOpen && this.deactivateGroup(), void 0 !== r && this.props.opened !== t.opened && (this.setState({
        openedState: this.props.opened
      }), this.props.onClick && this.props.onClick(this.props.groupId));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        e = _this$props.groupId,
        o = _this$props.sticky,
        n = _this$props.testMode;
      return o ? t(i, {
        "data-testid": n ? "stickycontainer_".concat(e) : void 0,
        "sticky-div": "stickyDiv",
        children: this.renderGroup()
      }) : this.renderGroup();
    }
  }]);
  return u;
}(n);
u.componentType = "AccordionItem", u.defaultProps = {
  activeID: null,
  groupIndex: 1,
  groupId: null,
  surface: "light",
  opened: !1,
  type: "multi",
  sticky: !1,
  testMode: !1,
  alwaysOpen: !1,
  bottomLine: !0,
  topLine: !0
}, u.componentType = "AccordionItem";
export { u as default };